import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our Digital Marketing Services for Sustainable Authority & Growth
            </h2>
            <p>
              We do not promise overnight success, but a credible,
              high-authority, and sustainable digital brand with consistent,
              valid traffic inflow and lead generation. Our digital marketing
              services are designed to deliver measurable results through
              proven, data-driven strategies.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>SEO</h4>
                  <p>
                    Enhance your website's visibility with technical SEO audits
                    and SERP performance optimization strategies. Our
                    comprehensive{" "}
                    <Link to="/search-engine-optimization">
                      search engine optimization services
                    </Link>{" "}
                    ensure high SERP rankings through data-driven analysis and
                    continuous performance monitoring. Boost organic traffic and
                    achieve sustainable growth with our precise SEO techniques.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>SEM</h4>
                  <p>
                    Drive targeted traffic with precision{" "}
                    <Link to="/search-engine-marketing">
                      search engine marketing services
                    </Link>
                    . Our PPC campaigns focus on optimal keyword bidding, ad
                    copy testing, and budget management. Increase ROI and
                    visibility through continuous optimization and advanced
                    analytics. Achieve measurable results with our
                    performance-driven SEM solutions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>SMM</h4>
                  <p>
                    Maximize your brand's reach with strategic{" "}
                    <Link to="/social-media-marketing-services">
                      social media marketing services
                    </Link>
                    . We craft tailored content, engage with your audience, and
                    leverage data analytics to optimize campaigns. Enhance brand
                    awareness, drive engagement, and achieve conversion goals
                    with our expert SMM services.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRO</h4>
                  <p>
                    Convert more visitors into customers with advanced CRO
                    techniques. We use A/B testing, heatmap analysis, and user
                    behavior insights to improve website usability. Enhance user
                    experience and increase conversion rates with our
                    data-backed CRO strategies.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Content Marketing</h4>
                  <p>
                    Engage and inform your audience with high-quality content
                    marketing. Our services include content creation,
                    distribution, and performance tracking. Drive organic
                    traffic, build brand authority, and foster customer loyalty
                    with our strategic content marketing approach.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Email Marketing</h4>
                  <p>
                    Boost your communication strategy with targeted email
                    marketing. We design personalized campaigns, segment your
                    audience, and track performance metrics. Increase open
                    rates, click-through rates, and conversions with our
                    optimized email marketing solutions.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
